import { Component, OnInit, HostListener, ViewContainerRef } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { Router, NavigationExtras } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmationDialogComponent, ConfirmDialogModel } from 'src/app/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';
import { UserSubscriptionDilogComponent } from '../user-subscription-dilog/user-subscription-dilog.component';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-wms-users',
  templateUrl: './wms-users.component.html',
  styleUrls: ['./wms-users.component.scss']
})
export class WmsUsersComponent implements OnInit {
  @HostListener('getWmsUserList')
  @HostListener('getAllAdminWmsUserList')

  private ResponseVerifiedWmsUserList: Subject<any> = new Subject();
  private ResponseVerifiedAdminWmsUserList: Subject<any> = new Subject();
  private ResponseVerifiedGetDeviceForNormalUser: Subject<any> = new Subject();
  private ResponseVerifiedChangePassword: Subject<any> = new Subject();

  pipe = new DatePipe('en-US');
  wmsUserList:[];
  page =1;
  closeResult:string;
  dataObject: {};
  role: any;
  epcId:any;
  srcString: any;
  roleName: string;
  userChangePasswordRequestObject: any = {};
  search:any = "";
  Limit = 10;
  OffsetWmsUser = 0;
  offset:any=0;
  deviceObject:any = {};
  adminWmsUserList: any;
  wmsUserDeviceList: any =[];
  devices: any;
  demo: any;
  selectedUserId: any;
  wmsUserCount: any;
  constructor(private viewContainer: ViewContainerRef,private dialog: MatDialog,private dashbord:DashboardService,private toastr: ToastrService, private router:Router,
    private modalService1: NgbModal) {
    this.role = localStorage.role;
    this.epcId = localStorage.id;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    }
  }

  ngOnInit() {
    if(this.roleName == 'epc'){
      this.getWmsUserList(this.search,this.Limit,this.OffsetWmsUser);
    }

  }

  // get allEpc WmsuserList
  getWmsUserList(search,limit,offset) {
    if(offset == 0){
      this.page = 1;
    }
    this.dataObject = {
      search: search,
      limit:limit,
      offset: offset
    }
    this.dashbord.getWmsUserList(this.dataObject)
    .pipe(takeUntil(this.ResponseVerifiedWmsUserList))
    .subscribe(
      async data => {
        this.wmsUserCount = 0 ;
        if(data.status){
          this.wmsUserCount=data.count;
          this.wmsUserList = data.resultObject;

        }  else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.wmsUserList = data.resultObject;
            this.toastr.info(data.message);
          }
        }
      },
      err => {
        return console.error(err);
      }
    );
  }

editWmsUser(userId){
  let navigationExtras: NavigationExtras = {
    queryParams: {
      'id': userId,
    }
  };
  this.router.navigate(['/inject-solar/add-wms-user/'], navigationExtras)
}
addDevice(userId){
  let navigationExtras: NavigationExtras = {
    queryParams: {
      'id': userId,
      "isEditing":"false",
      'usertype':"wmsuser"
    }
  };
  this.router.navigate(['/inject-solar/register-device/'], navigationExtras)
}


 // EDIT DEVICE
 EditDevice(userId,is_emeter){
  let navigationExtras: NavigationExtras = {
    queryParams: {
      'id': userId,
      "isEditing":"true",
      'usertype':"wmsuser",
      'is_emeter':is_emeter
    }
  };
  this.router.navigate(['/inject-solar/register-device-wmsuser'], navigationExtras)
}

viewDevice(viewDevices, userId) {
  this.wmsUserDeviceList=[];
  this.getDeviceForwmsUser(userId);
  this.modalService1.open(viewDevices, {size:<any> 'xl'});
     }

    ChangeDate(Chnagedate) {
      this.modalService1.open(Chnagedate, {size:<any> 'md'});
        }

  // get devices by user id
    getDeviceForwmsUser(userId){
    this.deviceObject = {
      epc_id:  this.epcId,
      user_id: userId,
    }
      this.dashbord.getWmsUserDevicesById( this.deviceObject)
      .pipe(takeUntil(this.ResponseVerifiedGetDeviceForNormalUser))
      .subscribe(
        async data => {
          this.wmsUserDeviceList=[];
          if(data.status){
            this.wmsUserDeviceList = data.device_info;

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

}

// change password modal start
openResetPasswordDialog(content, id) {
  this.selectedUserId = id;
  this.modalService1.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  }, (reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  });
}
private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return `with: ${reason}`;
  }
}

onUpdate(formData) {
  this.userChangePasswordRequestObject = {
    user_id: this.selectedUserId,
    new_password: formData.value.newPassword,
    confirm_password: formData.value.confirmPassword
  };
  this.changePasswordByUserId(this.userChangePasswordRequestObject);
}

 // change password by userid
 changePasswordByUserId(userChangePasswordRequestObject) {

  this.dashbord.changePasswordByUserId(userChangePasswordRequestObject)
    .pipe(takeUntil(this.ResponseVerifiedChangePassword))
    .subscribe(
      async data => {
        if (data.status) {
          this.toastr.success('Password Changed Successfully!!');
          this.modalService1.dismissAll();
          this.getWmsUserList(this.search,this.Limit,this.OffsetWmsUser);


        }  else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(data.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
}

nextPageWmsUser(pageIndex): void {

  this.OffsetWmsUser = (pageIndex - 1) * 10;
 // this.page = pageIndex;
    this.getWmsUserList(this.search,this.Limit,this.OffsetWmsUser);
}
public confirmDialog(id: any): void {
  let message = "Are you sure you want to delete this User?";
  let title = "Confirm Action";
  const dialogData = new ConfirmDialogModel(title,message);
  const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
    width: '400px',
    data: dialogData
  });
  dialogRef.afterClosed().subscribe(result => {
    if(result) {
       this.deleteWmsuserByUserId(id);
    }
  });
}

deleteWmsuserByUserId(id) {
var wmsUserIdObj ={
  user_id : id,
}
  this.dashbord.deleteWmsUserByEpc(wmsUserIdObj)
    .pipe(takeUntil(this.ResponseVerifiedChangePassword))
    .subscribe(
      async data => {
        if (data.status) {
          this.toastr.success(data.message);
          this.getWmsUserList(this.search,this.Limit,this.OffsetWmsUser);


        }  else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(data.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
}
 // renew user subscription dilog box
 public confirmRenewDialog(id: any): void {
    const dialogRef = this.dialog.open(UserSubscriptionDilogComponent, {
    width: '400px',
    // data: dialogData
  });
  dialogRef.afterClosed().subscribe(result => {
  if(result!=undefined){
    if(result.start_date !=undefined && result.start_date !="" && result.start_date !=null && result.end_date !="" && result.end_date !=undefined &&result.end_date !=null ) {
       this.renewSubscriptionUser(id,result);
    }
  }
  });
}

// renew user by id
renewSubscriptionUser(id,result) {
  var subscriptionNormalUserObj = {
    user_id: id,
    start_dt:this.pipe.transform(result.start_date, "yyyy-MM-dd"),
    end_year:result.end_date
  }
  this.dashbord.epcWmsUserSubscription(subscriptionNormalUserObj)
    .pipe(takeUntil(this.ResponseVerifiedAdminWmsUserList))
    .subscribe(
      async data => {
        if (data.status) {
          this.toastr.success(data.message);
          this.getWmsUserList(this.search,this.Limit,this.OffsetWmsUser);

        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(data.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
}
ngOnDestroy() {
  this.ResponseVerifiedWmsUserList.next();
  this.ResponseVerifiedWmsUserList.complete();

  this.ResponseVerifiedAdminWmsUserList.next();
  this.ResponseVerifiedAdminWmsUserList.complete();

  this.ResponseVerifiedGetDeviceForNormalUser.next();
  this.ResponseVerifiedGetDeviceForNormalUser.complete();

  this.ResponseVerifiedChangePassword.next();
  this.ResponseVerifiedChangePassword.complete();
}

}
